import { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getWatermark, updateWatermark } from "../../api/adminApi";
import { sendAlert } from "../../app/alertSlice";
import AdminLayout from "../component/AdminLayout";
import { ALERTCODE_ERR, ALERTCODE_INF } from "../component/AlertMe";

export default function SystemSettingPage() {
    document.title = '系统设置';
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [watermark, setWaterMark] = useState("")

    useEffect(() => {
        getWatermark()
            .then(res => {
                setWaterMark(res.data)
            })
    }, [])

    const changeWatermark = () => {
        setLoading(true)
        updateWatermark(watermark)
            .then(() => {
                dispatch(sendAlert({ code: ALERTCODE_INF, msg: '修改成功' }))
            })
            .catch(() => {
                dispatch(sendAlert({ code: ALERTCODE_ERR, msg: '修改失败' }))
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <AdminLayout>
            <Container>
                <Row>
                    <Col>
                        <Form.Group>
                            <Form.Label>水印设置</Form.Label>
                            <Form.Control
                                value={watermark}
                                onChange={(e) => setWaterMark(e.target.value)}
                            />
                            <Button onClick={changeWatermark} disabled={loading}>确认修改</Button>
                        </Form.Group>
                    </Col>
                </Row>
            </Container>
        </AdminLayout>
    )
}